var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.95166 16.5H5.8432C4.61434 16.5 3.63692 15.936 2.75932 15.1474C0.962773 13.5331 3.91244 12.243 5.03744 11.6112C7.06553 10.4722 9.51282 10.2088 11.7348 10.8211",
    stroke: "#77797E",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7228 4.875C13.7228 6.73896 12.1207 8.25 10.1445 8.25C8.16823 8.25 6.56616 6.73896 6.56616 4.875C6.56616 3.01104 8.16823 1.5 10.1445 1.5C12.1207 1.5 13.7228 3.01104 13.7228 4.875Z",
    stroke: "#77797E",
    strokeWidth: 1.125
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2601 10.3864C15.5267 10.1138 15.66 9.97764 15.8017 9.89814C16.1435 9.70636 16.5645 9.70044 16.912 9.88239C17.0561 9.95784 17.1935 10.0903 17.4684 10.355C17.7432 10.6199 17.8806 10.7523 17.9589 10.8911C18.1478 11.2259 18.1416 11.6315 17.9425 11.9609C17.8601 12.0974 17.7187 12.2258 17.4358 12.4828L14.0709 15.5396C13.535 16.0265 13.267 16.2699 12.9321 16.3933C12.5972 16.5167 12.229 16.5076 11.4927 16.4894L11.3925 16.487C11.1683 16.4814 11.0563 16.4786 10.9911 16.4089C10.9259 16.3391 10.9348 16.2314 10.9526 16.0161L10.9623 15.8991C11.0124 15.293 11.0373 14.9899 11.1629 14.7174C11.2884 14.4449 11.5048 14.2238 11.9378 13.7813L15.2601 10.3864Z",
    stroke: "#77797E",
    strokeWidth: 1.125,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserEdit);
export default __webpack_public_path__ + "static/media/user-edit.58db0b137e2440268fc68a95bcdc44a2.svg";
export { ForwardRef as ReactComponent };